import { QueryEvent, QueryItem } from '@restore/queries/queries.types';
import { FC } from 'react';
import { StatusQuery } from '@components/Queries/StatusQyery';
import { STATUS_QUERY_COLORS } from '@components/Queries/constants';
import { AttachIcon, ChatBubbleIcon } from '@dynamika-shared/ui/icons';
import { QueryDropdown } from '@components/Queries/Dropdown';
import { UserRoles } from '@dynamika-shared/types/auth';
import { useNavigate } from 'react-router-dom';
import { routesPath } from '@router/routes';
import { replacePathParams } from '@utils/replacePathWithParams';

type Props = {
  query: QueryItem;
  selectedRole: UserRoles;
  onSubmit: (
    event: QueryEvent,
    query: QueryItem,
    data: {
      username: string | null | undefined;
      password: string | null | undefined;
      signAgreement: boolean | null | undefined;
      message: string;
      attachments: File[];
    }
  ) => void;
  updating: boolean;
};

export const QueryCard: FC<Props> = ({
  query,
  selectedRole,
  onSubmit,
  updating,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className='border border-pastelBlue hover:bg-waterLightHover50 rounded-sm w-full p-2 mt-1.5 -me-1 cursor-pointer'
      onClick={() =>
        navigate(
          replacePathParams(routesPath.qcQuery, {
            id: query.clinicalTrialId,
            queryId: query.id,
          })
        )
      }
    >
      <header className='max-w-auto flex items-center justify-between gap-1'>
        <div className='flex items-center gap-1 grow w-full'>
          <span
            className={'w-1 h-1 rounded ' + STATUS_QUERY_COLORS[query.status]}
          >
            <svg width='8' height='8' viewBox='0 0 8 8'>
              <circle cx='3' cy='3' r='3' fill='currentColor' />
            </svg>
          </span>
          <span className='text-dimGray text-1624 font-medium uppercase'>
            {query.queryNumber}
          </span>
          <StatusQuery status={query.status} />
        </div>
        <QueryDropdown
          query={query}
          selectedRole={selectedRole}
          onSubmit={onSubmit}
          updating={updating}
        />
      </header>
      <div className='mt-2'>
        <h3 className='text-1624 font-semibold'>{query.types?.join(', ')}</h3>
        <div className='mt-1'>{query.description}</div>
      </div>
      <div className='flex items-center gap-1 mt-3'>
        <div className='text-1424 font-medium flex items-center gap-1 pe-2 border-pastelBlue border-e-2'>
          <AttachIcon className='w-3 h-3 text-pastelBlue' />
          {query.attachmentCount}
        </div>
        <div className='text-1424 font-medium flex items-center gap-1'>
          <ChatBubbleIcon className='w-3 h-3 text-pastelBlue' />
          {query.messageCount}
        </div>
      </div>
    </div>
  );
};
